import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CadastroPageModule } from '../pages/cadastro/cadastro.module';
import { LoginPageModule } from '../pages/login/login.module';
import { DrawerPageModule } from '../pages/drawer/drawer.module';
import { RecuperarSenhaPageModule } from '../pages/recuperar-senha/recuperar-senha.module';
import { environment } from '../environments/environment.dev';
import { HttpInterceptorProvider } from '../providers/http-interceptor/http-interceptor';
import { ReportsProvider } from '../providers/reports/reports';
import { AtlasPatologiaPageModule } from '../pages/atlas-patologia/atlas-patologia.module';
import { FileTransfer } from '@ionic-native/file-transfer';
import { EventoAdversoPageModule } from '../pages/evento-adverso/evento-adverso.module';
import { DetalheAtlasPageModule } from '../pages/detalhe-atlas/detalhe-atlas.module';
import { DetalheProdutoPageModule } from '../pages/detalhe-produto/detalhe-produto.module';
import { HomePageModule } from '../pages/home/home.module';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

registerLocaleData(localePt, 'pt-BR');


export function baseUrlFunc() {
  console.log("env", environment.baseUrl)
  return environment.baseUrl;
}

export const API_BASE_URL = ""

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserAnimationsModule,
    CadastroPageModule,
    IonicModule.forRoot(MyApp),
    HttpClientModule,
    LoginPageModule,
    DrawerPageModule,
    RecuperarSenhaPageModule,
    AtlasPatologiaPageModule,
    EventoAdversoPageModule,
    DetalheAtlasPageModule,
    DetalheProdutoPageModule,
    HomePageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    HttpInterceptorProvider,
    ReportsProvider,
    FileTransfer,
    ScreenOrientation
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts